import React from "react";

const NotFound404: React.FC = () => {
    return (
        <div>Error 404! - your page is not here!</div>
    );
};

export default NotFound404;
